// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const LabelContract = contract({
  name: "Label",
  description: "Every Input / Textarea / Checkbox / Switch / RadioGroup. Always use htmlFor so clicking the label focuses the control. Match `size` to the field it labels (size=\"xs\" label over a size=\"xs\" input).",
  import: "@gradeui/ui",
  aliases: ["label","form label","field label","caption"],
  element: "label",
  composesWith: ["Input","Textarea","Checkbox","Switch","RadioGroup","Select"],
  styleDefaults: {"Label":"font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm"},
  variantDefaults: {"size":"default"},
  props: {
  "htmlFor": {
      schema: z.string().optional(),
      design: "content",
      description: "binds to the input's id",
  },
  "size": {
      schema: z.enum(["default", "sm", "xs"]).optional(),
      design: "knob",
      description: "text size, mirrors Input/Select/Textarea so a field and its label scale together. default = text-sm; xs = 11px for dense tool panels.",
  },
  },
});
